export type BlockType = BasicType;

export const LEGACY_RAW_BLOCK_TYPE = 'raw';

// 基础组件
export enum BasicType {
	PAGE = 'page',
	SECTION = 'section',
	COLUMN = 'column',
	GROUP = 'group',
	TEXT = 'text',
	IMAGE = 'image',
	DIVIDER = 'divider',
	SPACER = 'spacer',
	BUTTON = 'button',
	WRAPPER = 'wrapper',
	RAW = 'html',
	ACCORDION = 'accordion',
	ACCORDION_ELEMENT = 'accordion-element',
	ACCORDION_TITLE = 'accordion-title',
	ACCORDION_TEXT = 'accordion-text',
	HERO = 'hero',
	CAROUSEL = 'carousel',
	NAVBAR = 'navbar',
	SOCIAL = 'social',
	// TODO
	TABLE = 'table',

	TEMPLATE = 'template',
}

// 高级组件
export enum AdvancedType {
	TEXT = 'advanced_text',
	IMAGE = 'advanced_image',
	DIVIDER = 'advanced_divider',
	SPACER = 'advanced_spacer',
	BUTTON = 'advanced_button',
	NAVBAR = 'advanced_navbar',
	SOCIAL = 'advanced_social',
	ACCORDION = 'advanced_accordion',
	CAROUSEL = 'advanced_carousel',
	TABLE = 'advanced_table',

	WRAPPER = 'advanced_wrapper',
	SECTION = 'advanced_section',
	COLUMN = 'advanced_column',
	GROUP = 'advanced_group',
	HERO = 'advanced_hero',
}

// Dynamic content blocks
export enum DynamicType {
	IMAGE = 'dynamic_image',
}

export const MERGE_TAG_CLASS_NAME = 'bay-email-merge-tag-container';

// Marks a resolved merge tag in the RASTER copy of a design. The raster
// stylesheet keys its dashed underline off this class, so a field that has been
// replaced with real data still reads as dynamic. Shared with bay-ui's
// buildMergeTagContextHtml, which stamps the same class on the tags it wraps —
// the two must not drift.
export const MERGE_FIELD_CLASS = 'bay-merge-field';
export const EMAIL_BLOCK_CLASS_NAME = 'email-block';

// Pattern to detect inline color styles in HTML (only matches 'color:', not 'background-color:', etc.)
export const INLINE_COLOR_PATTERN = /(?:(?<![\w-])color\s*:|<font[^>]*\scolor\s*=)/i;
